import {useState} from "react";
import Tippy from '@tippyjs/react/headless';
import {Button, Icon, PopperWrapper} from "~/components";

function MarketingProjectAction({item, can, onClickEdit, onClickAssign, onClickReactivate, onClickDelete}) {

	const [showActionBox, setShowActionBox] = useState(false);

	//Chỉ cho kích hoạt lại khi dự án không còn ở trạng thái "đang thực hiện" (đã hoàn thành / bàn giao)
	const canReactivate = can?.status && (item?.status?.key || item?.status) !== 'doing';

	const actionButtons = [
		can?.edit && <Button key="edit" leftIcon={Icon.edit} onClick={() => {onClickEdit?.(item); setShowActionBox(false)}}>Cập nhật thông tin</Button>,
		can?.assign && <Button key="assign" leftIcon={Icon.user} onClick={() => {onClickAssign?.(item); setShowActionBox(false)}}>Phân kỹ thuật</Button>,
		canReactivate && <Button key="reactivate" leftIcon={Icon.reload} onClick={() => {onClickReactivate?.(item); setShowActionBox(false)}}>Kích hoạt lại</Button>,
		can?.delete && <Button key="delete" leftIcon={Icon.delete} onClick={() => {onClickDelete?.(item); setShowActionBox(false)}} outline red noneBorder> Xóa dự án</Button>,
	];

	return (
		<div className="table-action d-flex">
			{(can?.edit || can?.assign || canReactivate || can?.delete) && (
				<Tippy
					interactive
					visible={showActionBox}
					onClickOutside={() => setShowActionBox(false)}
					render={() => (
						<PopperWrapper className="action-wrapper" style={{minWidth: '220px', minHeight: 'auto'}}>
							{actionButtons}
						</PopperWrapper>
					)}
					placement="left"
					offset={[0, -10]}
				>
					<div onClick={() => setShowActionBox(!showActionBox)} className="action-btn">
						{Icon.menuVertical}
					</div>
				</Tippy>
			)}
		</div>
	)
}

export default MarketingProjectAction;
